import axios from "axios";
var Axios = axios.create({
    baseURL: window.SITE_CONFIG.baseApiUrl,

    // baseURL:"http://webapi.sxszstm.com/"
    // webapi.sxszstm.com
});
// const baseUrl = 'http://www.sxszstm.com/'
// 请求拦截
Axios.interceptors.request.use(
  (config) => {
    // token认证写在这里
    return config;
  },
  (err) => {
    Promise.reject(err);
  }
);
// 响应拦截
Axios.interceptors.response.use(
  (config) => {
    return config;
  },
  (err) => {
    Promise.reject(err);
  }
);
// get封装

export function get(url, params = {}) {

  return new Promise((resolve, reject) => {
    Axios({
        url: url,
        params,
        method: "get",
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
// post封装
export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios({
        url:  url,
        method: "post",
        data,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
// delete封装
export function del(url, params = {}, data = {}) {
    return new Promise((resolve, reject) => {
      Axios({
        url:  url,
        method: "delete",
        params,
        data,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
//   Blob封装,resopnseType:Blob一般是用于文件下载
export function getBlob(url, params = {}) {
    return new Promise((resolve, reject) => {
      Axios({
        url:  url,
        method: "get",
        params,
        responseType:'blob'
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
const httpRequests = {
    get,
    post,
    del,
    getBlob
}
export default httpRequests



// WEBPACK FOOTER //
// ./src/api/baseUrl.js